import ChevronRightActiveIcon from "Assets/Icons/ChevronRightActiveIcon";
import NotMarkedNew from "Assets/Icons/NotMarkedIconNew";
import NotMarkedNewWhite from "Assets/Icons/NotMarkedNewWhite";
import TickIcon from "Assets/Icons/TickIcon";
import TickIconMB from "Assets/Icons/TickIconMB";
import TickIconWhite from "Assets/Icons/TickIconWhite";
import Typography from "Components/CommonComponents/Typography";
import React from "react";
import { convertTime } from "utilFunctions/helperFunctions/convertTime";

interface IMyScheduleDateView {
  dateItem?: any;
  scheduleData?: any;
  active?: boolean;
  statusResponseMap?: any;
  unmarkedLecture?: any;
  totalLength?: any;
  isNotmarkedVisible?: any;
  screen?: any;
}
function MyScheduleDateView({
  dateItem,
  active,
  statusResponseMap,
  unmarkedLecture,
  totalLength,
  isNotmarkedVisible,
  screen,
}: IMyScheduleDateView) {
  //   const [dateViewData, setDateViewData] = useState<any>(
  //     dateItem ? dateItem : {}
  //   );
  const todayDate = new Date().toISOString().split("T")[0];
  const dateViewData = dateItem ? dateItem : {};
  return (
    <div className="w-100 d-flex  justify-content-between">
      <div className="w-100 d-flex flex-column justify-content-start">
        <div className="d-flex flex-row">
          <div style={{ width: "50%" }}>
            <Typography
              variant="subheadingSB1"
              color={active ? "white" : "black"}
            >
              {convertTime(dateViewData, "D MMM, ddd")}
            </Typography>
          </div>
          <div className="ml-0" style={{ width: "50%" }}>
            {isNotmarkedVisible ? (
              <div className="ml-2">
                {" "}
                <>{!active ? <NotMarkedNew /> : <NotMarkedNewWhite />}</>
              </div>
            ) : statusResponseMap &&
              statusResponseMap != null &&
              statusResponseMap[dateViewData] == "Unmarked" ? (
              <div className="ml-2">
                {" "}
                <>{!active ? <NotMarkedNew /> : <NotMarkedNewWhite />}</>
              </div>
            ) : statusResponseMap &&
              statusResponseMap != null &&
              statusResponseMap[dateViewData] == "Marked" &&
              todayDate != dateViewData ? (
              <div className="ml-2">
                {" "}
                {["xxl", "xl", "lg"].includes(screen) ? (
                  <>{!active ? <TickIcon /> : <TickIconWhite />}</>
                ) : (
                  <TickIconMB></TickIconMB>
                )}
              </div>
            ) : null}
          </div>
        </div>
        {active &&
        todayDate != dateViewData &&
        new Date(dateViewData) < new Date(todayDate) ? (
          <div className="d-flex flex-row w-100 justify-content-between">
            <Typography variant="forminfo" color="white">
              {totalLength - unmarkedLecture} out of {totalLength} are marked
            </Typography>
          </div>
        ) : null}
      </div>
      <div className="d-flex align-items-center">
        <ChevronRightActiveIcon />
      </div>
    </div>
  );
}

export default MyScheduleDateView;
